// removed by extract-text-webpack-plugin
module.exports = {"carriers-carousel-section":"src-components----CarriersCarouselSection-module---carriers-carousel-section---1wgmh","carriers-carousel-container":"src-components----CarriersCarouselSection-module---carriers-carousel-container---bZjI1","disclaimer-container":"src-components----CarriersCarouselSection-module---disclaimer-container---2E7HZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CarriersCarouselSection.module.scss
// module id = 652
// module chunks = 35783957827783